<script setup lang="ts">
import { computed, toRef } from "vue";
import ResultsLineChart from "../Charts/ResultsLineChart.vue";
import AnalysisCardShell from "./AnalysisCardShell.vue";
import { useKpiTrendData } from "@/composables/useKpiMetric";

const props = defineProps({
  card: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
});

const cardRef = toRef(props, "card");
const { series, categories, hasData, isConfigured, withWeights } = useKpiTrendData(cardRef);

const chartType = computed(() => props.card.options?.chart_type || "line");
const state = computed(() => (!isConfigured.value ? "unconfigured" : hasData.value ? "ready" : "empty"));
</script>

<template>
  <AnalysisCardShell
    :card="card"
    :readonly="readonly"
    :weighted="isConfigured && withWeights"
    :state="state"
    :state-message="state === 'empty' ? 'Add populations (waves) to plot the trend.' : ''">
    <ResultsLineChart :series="series" :categories="categories" :type="chartType" />
  </AnalysisCardShell>
</template>
